<template>
  <div class="iv-appra-declare-enroll">
    <section class="iv-main-width iv-p-t-40 iv-enroll-top iv-p-b-40">
      <Expand :defaultExpand="true">
        <h1 class="iv-fs-24 iv-fc-85" slot="title">{{declareInfo.applicationName}}</h1>
        <p class="iv-m-t-12 iv-fs-16 iv-fc-65">发布组织：{{declareInfo.publishOrgName}}</p>
        <Row class="iv-m-t-12">
          <Col :span="8" class="iv-fs-16 iv-fc-65">发布人：{{declareInfo.publisherName}}</Col>
          <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)邮箱：{{declareInfo.publisherEmail}}</Col>
          <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)联系方式：{{declareInfo.publisherContact}}</Col>
        </Row>
        <p class="iv-m-t-12 iv-fs-16 iv-fc-65 iv-enroll-top-description">
          <span>申报说明(要求与条件)：</span>
          <span v-html="declareInfo.applicationExplain"></span>
        </p>
        <Expand class="iv-m-t-12 iv-fs-16 iv-fc-65" :showText="false">
          <template slot="title">
            <IconFont type="link" class="iv-m-r-8"></IconFont>
            <span>附件资料</span>
          </template>
          <Upload :readOnly="true" :isShowFileList="true" :multiple="true" :getUploadFiles="declareInfo.initalFile" class="iv-m-t-12"></Upload>
        </Expand>
      </Expand>
    </section>
    <div class="iv-p-t-40 iv-enroll-content">
      <div class="iv-main-width">
        <section>
          <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-16">包含项目</h1>
          <ul class="iv-enroll-content-ul">
            <li
              @click="onSelectPrize(item, index)"
              class="iv-fs-16 iv-fc-65 iv-m-t-24 iv-pull-left iv-pointer" 
              :class="{'iv-enroll-active': index === currentIndex}" 
              v-for="(item, index) in prizeList" :key="index">
              <IconFont type="sign" class="iv-m-r-12"></IconFont>{{item.objectName}}
            </li>
          </ul>
          <div class="iv-m-t-24 iv-enroll-content-desc">
            <p class="iv-fs-16 iv-fc-65">申报说明(要求与条件)：{{prizeDesc}}</p>
            <Expand class="iv-m-t-12 iv-fs-16 iv-fc-65" :showText="false">
              <template slot="title">
                <IconFont type="link" class="iv-m-r-8"></IconFont>
                <span>附件资料</span>
              </template>
              <Upload :readOnly="true" :isShowFileList="true" :multiple="true" :getUploadFiles="prizeFiles" class="iv-m-t-12"></Upload>
            </Expand>
          </div>
        </section>
        <section class="iv-p-t-40">
          <Expand :defaultExpand="true">
            <div class="iv-app-detail-fill" slot="title">
              <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line">申报报名</h1>
              <p class="iv-fs-16 iv-pointer iv-main-color"
                style="margin-right: 80px;"
                v-if="readOnly && !isDisabled && isCancel != 1"
                @click="quickHandler">
                <IconFont type="xuanze" class="iv-m-r-12"></IconFont>从已报名中选择，快速填写
              </p>
            </div>
            <LayoutTitle class="iv-m-t-20" :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
              <FormLayout
                ref="projectForm" 
                :readOnly="isDisabled"
                :model="projectInfo"
                :list="generatePage(index)"
                @on-change-tree="checkPerson"
                @on-change-all="checkMember"
                @on-upload-success="onUploadSucess(...arguments)">
              </FormLayout>
            </LayoutTitle>
          </Expand>
        </section>
        <section class="iv-m-t-24">
          <Expand :defaultExpand="true">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line" slot="title">项目团队成员</h1>
            <LayoutTitle title="项目团队成员" :showBtn="true" :readOnly="isDisabled" btnText="添加成员" icon="append" @on-click="addPerson">
              <DragTable
                class="iv-m-t-24"
                noSearch
                :showEdit="!isDisabled"
                :showDelete="!isDisabled"
                :showSelect="false"
                :showPage="false"
                ref="DragTable" 
                :immediateForce="true" 
                :columns="column" 
                :tableData="tableData">
              </DragTable>
            </LayoutTitle>
          </Expand>
        </section>
        <section class="iv-m-t-40 iv-p-b-40" style="min-height: 120px;">
          <Expand :defaultExpand="true">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line" slot="title">项目进度记录</h1>
            <LayoutTitle class="iv-m-t-24" title="计划与进度" :readOnly="isDisabled" :showBtn="true" btnText="新增阶段" icon="append" @on-click="addPlan">
              <DragTable
                class="iv-m-t-24 iv-p-b-40"
                noUrl
                noSearch
                :showEdit="!isDisabled"
                :showDelete="!isDisabled"
                :showSelect="false" 
                :showPage="false"
                ref="DragTable" 
                :immediateForce="true" 
                :columns="planColumn" 
                :tableData="planTableData">
              </DragTable>
            </LayoutTitle>
          </Expand>
        </section>
        <slot></slot>
      </div>
    </div>
    <!-- 快速填写 -->
    <QuickModal ref="QuickModal"></QuickModal>
    <!-- 打分 -->
    <ScoreModal ref="ScoreModal" v-if="businessId"></ScoreModal>
    <!-- 选人 -->
    <SelectMember :treeType="treeType" ref="SelectMember" :hideSelectInput="true" v-model="tableData" :listProps="listProps" @on-change-all="confirmSelect"></SelectMember>
    <FooterOperator>
      <div class="iv-text-center">
        <Button class="iv-m-r-8" type="save" @click="scoreHandler" v-if="businessId && score != 'result'">打分</Button>
        <span v-if="readOnly && !readType">
          <span v-if="currentPrize.childReportTimeLimit" class="iv-m-r-16 iv-fs-16" style="color: #CD170A;">
            上报时限：{{timeFormat(currentPrize.childReportTimeLimit)}}
          </span>
          <Button 
            class="iv-m-r-8" 
            type="submit" 
            @click="submit" 
            :disabled="computedLimitTime(currentPrize.childReportTimeLimit, currentPrize.forceLimitTime)" 
            v-if="!isDisabled && isCancel == 0"
          >提交报名</Button>
          <Button 
            class="iv-m-r-8" 
            type="cancel" 
            @click="cancel" 
            :disabled="computedLimitTime(currentPrize.childReportTimeLimit, currentPrize.forceLimitTime)" 
            v-if="!isDisabled && isCancel == 1"
          >申请取消</Button>
        </span>
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import {timeFormat} from '@/utils'
import column from './column.js'
import planColumn from './plan-column'
import Upload from '@/components/upload'
import generateList from './recommend.js'
import Expand from '@/components/expand-info'
import IconFont from '@/components/iconfont'
import ScoreModal from '@/views/review/modal'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import DragTable from '@/components/drag-table-inline'
import SelectMember from '@/components/select-input-member'
import FooterOperator from '@/components/footer-operator'
import { getSignUpId } from '../sbgl-interface/index.js'
import QuickModal from '@/views/appraising-declare/modal/index.vue'
import { getApplication, getMySignUpList, submitProjectSignUp, getProjectSignUp, editProjectSignUp, getApplicationInfoId } from '../interface'

export default {
  data () {
    return {
      currentIndex: 0,
      tableData: [],
      descInfo: {},
      planTableData: [],
      projectInfo: {}, //项目信息
      signUpId: '',
      dictMap: {},
      declareInfo: {}, //基础信息
      prizeList: [], //奖项列表
      applicationObjectId: '',
      prizeDesc: '',
      prizeFiles: [],
      personForm: [],
      groupId: '',
      isCancel: null,
      readOnly: false,
      currentPrize: {},
      dynamicFormId: '',
      dynamicList: [],
      treeType: {}
      // isDisabled: true
    }
  },
  async created () {
    const idMap = JSON.parse(sessionStorage.getItem('idMap'))
    const nameMap = JSON.parse(sessionStorage.getItem('nameMap'))
    this.readType = this.$route.query.type === 'see' || this.$route.query.isSignUp == true
    //评审打分相关参数
    this.businessId = this.$route.query.businessId || ''
    this.objectId = this.$decode(this.$route.query.objectId)
    this.businessCode = this.$decode(this.$route.query.businessCode)
    this.score = this.$decode(this.$route.query.score)
    this.backUrl = this.$route.query.backUrl
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.treeType = {
      type: 'async-change'
    }
    this.listProps = {
      async: true,
      type: 'checkbox',
      isAllResult: true,
      selectUserSwitch: true,
      // bizLineCode: this.bizLineCode,
      treeData: {
        rootId: ''
      },
      listData: {
        orgId: ''
      },
      sendListData: (id, name) => {
        return {
          orgId: id,
          userName: name,
          drillType: 1
        }
      },
      listUrl: '/api-uum/uum/org/tree/single/listOrgUser'
    }
    //本身的
    this.isDisabled = this.$decode(this.$route.query.type) == 'see'
    this.applicationInfoId = this.$decode(this.$route.query.applicationInfoId)
    this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
    this.orgName = this.$decode(sessionStorage.getItem(nameMap[this.bizLineCode]))
    // this.groupId = this.getUuid()
    this.setRecommendInfo()
    //初始化表单和表格
    this.column = column.call(this)
    this.planColumn = planColumn.call(this)
    this.getCodeTable('BOE12')
    this.getCodeTable('BOE14')
    this.getCodeTable('BOE15')
    await this.getCodeTable('BOE161')
    //评审打分
    if (this.businessId) {
      this.getBasicInfoForReview()
    } else {
      this.getDeclareBasicInfo()
    }
  },
  provide () {
    return {
      saveItem: this.saveItem,
      deleteItem: this.deleteItem,
      removeAdd: this.removeAdd,
      quickShowModal: this.quickShowModal
    }
  },
  methods: {
    timeFormat,
    //当前时间大于时限时间  按钮设置为禁用
    computedLimitTime (limitTime, forceLimitTime) {
      if (!limitTime || !forceLimitTime || forceLimitTime != 1) return false
      const currentTime = Date.now()
      return currentTime > limitTime + 86400000
    },
    //供快速填写使用
    quickShowModal (signUpId) {
      this.$nextTick(() => {
        this.getPersonInfo(signUpId)
      })
    },
    //快速填写弹框
    quickHandler () {
      this.$refs.QuickModal.open(this.currentPrize, this.bizLineCode)
    },
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //获取动态表单接口
    getDynamicFormInfo () {
      if (!this.dynamicFormId) return
      this.$ajax({
        url: 'api-general/dynamicform/form/getFormStructure',
        method: 'get',
        data: {
          formId: this.dynamicFormId,
          version: this.currentPrize.dynamicFormVersion
        }
      }).then(({data}) => {
        this.dynamicList = data.data.formGroupList
        this.transferDataType()
      })
    },
    // 取消申请
    cancel () {
      this.$ajax({
        url: 'api-general/module/selection/personalCenter/signUp/appraising/cancelProjectSignUp',
        method: 'put',
        data: {
          signUpId: this.signUpId,
          orgId: this.orgId
        }
      }).then((data) => {
        this.$Message.success('取消成功')
        this.getSignUpId()
      })
    },
    //评审打分  获取applicationId
    getBasicInfoForReview () {
      getApplicationInfoId({reportListId: this.businessId}).then(({data}) => {
        if (data && data.applicationInfoId) {
          this.applicationInfoId = data.applicationInfoId
          this.getDeclareBasicInfo(data.applicationObjectId)
        }
      })
    },
    //获取 评审打分查看的signUpId
    getReviewSignUpId () {
      getSignUpId ({listItemId: this.objectId}).then(({data}) => {
        this.signUpId = data.signUpId
        this.getPersonInfo()
        this.dynamicFormId = data.dynamicFormId
        this.currentPrize['dynamicFormVersion'] = data.dynamicFormVersion
        //动态表单
        this.getDynamicFormInfo()
      })
    },
    //评审打分
    scoreHandler () {
      this.$refs.ScoreModal.open()
    },
    onUploadSucess (file, index) {
      if (file.success) {
        this.groupId = file.response.data.groupId
        this.$Message.success('上传成功')
      }
    },
    //内部存储推荐信息  防止修改
    setRecommendInfo () {
      this.recommendInfo = {
        recommendOrgName: this.orgName,
        recommendOrgId: this.orgId,
        fillInUserName: this.$decode(sessionStorage.getItem('userName')),
        fillInUserId: this.$decode(sessionStorage.getItem('userId')),
        fillInUserEmail: this.$decode(sessionStorage.getItem('userEmail')),
        fillInUserPhone: this.$decode(sessionStorage.getItem('userPhone'))
      }
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => ref.validateify())
      return req
    },
    //将date对象格式化
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submit () {
      this.projectInfo.projEndDate = new Date(this.projectInfo.projEndDate)
      this.projectInfo.projStartDate = new Date(this.projectInfo.projStartDate)
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$Message.error('表单校验失败')
          return
        }
        let isContinue = this.validateTable()
        if (!isContinue) return
        const requestMethod = this.signUpId ? editProjectSignUp : submitProjectSignUp
        let params = this.dateFormat({
          ...this.projectInfo,
          signUpType: 'BMLX01',
          // projLeaderId: this.projectInfo.projLeaderName[0].userId,
          // projLeaderName: this.projectInfo.projLeaderName[0].userName,
          attachmentGroupId: this.groupId,
          applicationObjectId: this.applicationObjectId
        })
        if (this.tableData.length) {
          params.teamMemberLists = this.tableData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.tableData.length && params.teamMemberLists) {
          delete params.teamMemberLists
        }
        if (this.planTableData.length) {
          params.progressLists = this.planTableData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.planTableData.length && params.progressLists) {
          delete params.progressLists
        }
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          this.getSignUpId()
        })
      })
    },
    validateTable () {
      let isContinue = true
      if (this.tableData.length) {
        isContinue = this.tableData.every(item => !item.errorQueue)
        if (!isContinue) {
          this.$Message.warning('团队成员必填项未填写')
          return isContinue
        }
      }
      if (this.planTableData.length) {
        isContinue = this.planTableData.every(item => !item.errorQueue)
        if (!isContinue) {
          this.$Message.warning('进度记录必填项未填写')
          return isContinue
        }
      }
      return isContinue
    },
    //选择奖项
    onSelectPrize (item, index) {
      if (this.score == 'result' || this.score == 'score') return
      this.readOnly = false
      this.isCancel = null
      this.currentIndex = index
      this.prizeDesc = item.applicationExplain
      this.applicationObjectId = item.applicationObjectId
      this.signUpId = ''
      this.currentPrize = item
      this.dynamicFormId = item.dynamicFormId
      this.getSignUpId()
      this.groupId = '' //每次选择奖项时 清空附件id
      if (item.applicationFileGroupId) {
        this.getActivityFiles(item.applicationFileGroupId).then(files => {
          this.prizeFiles = files
        })
      }
    },
    //获取项目信息
    getPersonInfo (signUpId) {
      getProjectSignUp({ signUpId: signUpId || this.signUpId, orgId: this.orgId }).then(({data}) => {
        if (signUpId) {
          data.isCancel = '0'
        }
        this.isCancel = data.isCancel
        this.projectInfo = { ...this.recommendInfo, ...this.projectInfo, ...data }
        this.projectInfo.recommendOrderNum = this.projectInfo.recommendOrderNum ? this.projectInfo.recommendOrderNum + '' : ''
        // this.projectInfo.projLeaderName = [{
        //   userId: this.projectInfo.projLeaderId,
        //   userName: this.projectInfo.projLeaderName
        // }]
        this.tableData = data.teamMemberList.map(item => ({
          ...item,
          $type: 'member',
          userId: item.memberUserId || '',
          userName: item.memberUserName
        }))
        this.planTableData = data.progressList && data.progressList.map(item => ({
          ...item,
          $type: 'resume',
          actualCompletionDate: timeFormat(item.actualCompletionDate),
          plannedCompletionDate: timeFormat(item.plannedCompletionDate)
        }))
        //设置附件
        if (this.projectInfo.attachmentGroupId) {
          this.groupId = this.projectInfo.attachmentGroupId
          this.getActivityFiles(this.groupId).then(data => {
            this.$set(this.projectInfo, 'uploadFile', data)
          })
        }
        //动态表单
        this.getDynamicFormInfo()
      })
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.projectInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.projectInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker') {
            this.$set(this.projectInfo, val.propertyCode, value ? timeFormat(value) : '')
          }
        })
      })
    },
    //获取基础信息
    getDeclareBasicInfo (applicationObjectId = '') {
      getApplication({applicationInfoId: this.applicationInfoId}).then(({data}) => {
        this.declareInfo = data
        //获取申报附件
        if (data.applicationFileGroupId) {
          this.getActivityFiles(data.applicationFileGroupId).then(files => {
            this.$set(this.declareInfo, 'initalFile', files)
          })
        }
        if (this.declareInfo.applicationExplain) {
          this.declareInfo.applicationExplain = this.declareInfo.applicationExplain.replaceAll('\n', '<br />')
        }
        //获取申报下面的奖项列表
        this.prizeList = data.applicationObjectList || []
        let firstPrize = this.prizeList[0]
        //评审打分的时候 
        if (this.businessId) {
          const index = this.prizeList.findIndex(val => val.applicationObjectId == applicationObjectId)
          this.currentIndex = index
          firstPrize = this.prizeList[index] || ''
        }
        if (firstPrize) {
          this.currentPrize = firstPrize
          this.dynamicFormId = firstPrize.dynamicFormId
          this.prizeDesc = firstPrize.applicationExplain || ''
          this.applicationObjectId = firstPrize.applicationObjectId || ''
          if (firstPrize.applicationFileGroupId) {
            this.getActivityFiles(firstPrize.applicationFileGroupId).then(files => {
              this.prizeFiles = files
            })
          }
        }
        if (this.businessId) {
          this.getReviewSignUpId()
        } else {
          this.getSignUpId()
        }
      })
    },
    //获取signUpId
    getSignUpId () {
      getMySignUpList({applicationObjectId: this.applicationObjectId}).then(({data}) => {
        this.readOnly = true
        if (data && data.length) {
          this.isDisabled = !data[0].isReportState
          this.signUpId = data[0].signUpId
          this.getPersonInfo()
        } else {
          this.isDisabled = false
          this.isCancel = '0'
          this.tableData = []
          this.planTableData = []
          this.$set(this, 'projectInfo', {
            ...this.recommendInfo,
            uploadFile: []
          })
          //动态表单
          this.getDynamicFormInfo()
        }
      })
    },
    //选择单位
    checkPerson (data, key) {
      if (key == 'projPartyOrgName') {
        this.projectInfo.projPartyOrgId = data[0].id
      }
      if (data.userId) {
        this.$ajax({
          url: 'api-uum/uuminfo/getUserInfoByCode',
          method: 'GET',
          data: {
            userId: data.userId
          }
        }).then(({data}) => {
          this.$set(this.projectInfo, 'projLeaderName', data.data.userName || '')
          this.$set(this.projectInfo, 'projLeaderId', data.data.userCode || '')
          this.$set(this.projectInfo, 'projLeaderJobNumber', data.data.userCode || '')
          this.$set(this.projectInfo, 'projLeaderEmail', data.data.email || '')
          if(data.data.dutyCode) {
            this.$set(this.projectInfo, 'projLeaderAdminPost', data.data.dutyCode)
          } else {
            this.$set(this.projectInfo, 'projLeaderAdminPost', '')
          }
          this.$set(this.projectInfo, 'projLeaderPartyPost', data.data.positionNames || '')
        })
      }
    },
    //选人
    checkMember ([item], key) {
      if (key === 'projLeaderName') {
        // this.$set(this.projectInfo, 'projLeaderJobNumber', item.userCode || '')
        // this.$set(this.projectInfo, 'projLeaderEmail', item.email || '')
      } else if (key == 'projPartyOrgLeaderName') {
        this.$set(this.projectInfo, 'projPartyOrgLeaderId', item.userId || '')
        this.$set(this.projectInfo, 'projPartyOrgLeaderName', item.userName || '')
      }
    },
    //弹框确认选择
    confirmSelect (list) {
      const userIds = this.tableData.map(val => val.memberUserId)
      list.forEach(val => {
        if (!userIds.includes(val.userCode) && !userIds.includes(val.memberUserId)) {
          this.tableData.push({
            memberUserName: val.userName,
            memberUserId: val.userCode,
            $type: 'member',
            isEdit: true,
            contributionDegree: null,
            bonusPoints: null,
            _add: true,
            errorQueue: {},
            projRole: ''
          })
        }
      })
    },
    //新增人员
    addPerson () {
      this.$methods('SelectMember', 'onShowTree')
    },
    //新增阶段
    addPlan () {
      this.planTableData.push({
        isEdit: true,
        $type: 'resume',
        markingCompletionRate: null,
        _add: true,
        errorQueue: {},
        plannedCompletionDate: '',
        actualCompletionDate: '',
        phaseName: ''
      })
    },
    //点击取消
    removeAdd (index, item) {
      if (item._add) {
        const data = item.$type == 'member' ? 'tableData' : 'planTableData'
        this[data].splice(index, 1)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
        }
      }
    },
    //表格校验
    validateColumns (item) {
      let isContinue = true
      item.errorQueue = item.errorQueue || {}
      Object.keys(item).forEach(val => {
        if (val == 'isEdit' || val.indexOf('_') != -1) {
          item.errorQueue[val] = false
        } else if (!item[val]) {
          item.errorQueue[val] = true
          isContinue = false
        } else {
          item.errorQueue[val] = false
        }
      })
      return isContinue
    },
    //保存
    saveItem (item) {
      const index = item._index
      const isContinue = this.validateColumns(item)
      const data = item.$type == 'member' ? 'tableData' : 'planTableData'
      if (!isContinue) {
        this.$set(this[data], index, item)
        return Promise.reject(item)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
          if (i.indexOf('_') != -1) {
            delete item[i]
          }
        }
        delete item.errorQueue
        item.isEdit = false
        this[data].splice(index, 1, item)
        return Promise.resolve({item, showMessage: 'message'})
      }
    },
    //删除
    deleteItem (item) {
      if (item.$type == 'member') {
        this.tableData.splice(item._index, 1)
      }
      if (item.$type == 'resume') {
        this.planTableData.splice(item._index, 1)
      }
      return Promise.resolve(item)
    },
    //获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    //返回
    back () {
      if (this.backUrl == 'reviewGrade') {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: this.backUrl || 'projectList',
          query: {
            currentPage: this.$route.query.currentPage || 1,
            tabName: this.$route.query.tabName || ''
          }
        })
      }
    }
  },
  components: {
    FormLayout,
    Upload,
    QuickModal,
    Expand,
    IconFont,
    DragTable,
    LayoutTitle,
    SelectMember,
    ScoreModal,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-appra-declare-enroll {
  .iv-enroll-top {
    background: #F5F7FA;
    .iv-enroll-top-expand {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .iv-enroll-top-description {
      display: flex;
    }
  }
  .iv-app-detail-fill {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .iv-enroll-content {
    background: #fff;
    .iv-enroll-content-ul {
      overflow: hidden;
      li {
        width: 282px;
        padding: 18px 26px;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 24px;
        position: relative;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
        &.iv-enroll-active {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
        .iv-enroll-content-span {
          font-size: 16px;
          color: #fff;
          border-radius: 20px;
          padding: 8px 20px;
          position: absolute;
          right: -12px;
          top: -24px;
          background: #FFC757;
        }
        .iv-green {
          background: #45BC7D;
        }
      }
    }
    .iv-enroll-content-desc {
      background-color: #F5F7FA;
      border-radius: 16px;
      padding: 20px 24px;
    }
    .iv-enroll-content-selcect {
      color: #FA2900;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      text-decoration: underline;
      font-weight: 400;
    }
    .iv-enroll-block {
      h3 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
